"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateYouTubeChannelDto = instanceOfUpdateYouTubeChannelDto;
exports.UpdateYouTubeChannelDtoFromJSON = UpdateYouTubeChannelDtoFromJSON;
exports.UpdateYouTubeChannelDtoFromJSONTyped = UpdateYouTubeChannelDtoFromJSONTyped;
exports.UpdateYouTubeChannelDtoToJSON = UpdateYouTubeChannelDtoToJSON;
exports.UpdateYouTubeChannelDtoToJSONTyped = UpdateYouTubeChannelDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateYouTubeChannelDto interface.
 */
function instanceOfUpdateYouTubeChannelDto(value) {
    return true;
}
function UpdateYouTubeChannelDtoFromJSON(json) {
    return UpdateYouTubeChannelDtoFromJSONTyped(json, false);
}
function UpdateYouTubeChannelDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'] == null ? undefined : json['name'],
        'channel_id': json['channel_id'] == null ? undefined : json['channel_id'],
        'channel_url': json['channel_url'] == null ? undefined : json['channel_url'],
    };
}
function UpdateYouTubeChannelDtoToJSON(json) {
    return UpdateYouTubeChannelDtoToJSONTyped(json, false);
}
function UpdateYouTubeChannelDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'channel_id': value['channel_id'],
        'channel_url': value['channel_url'],
    };
}
